import axios from '@/plugins/axios'

export function getRechargeOrder(params = {}) {
  return axios.get('recharge_order', { params })
}

export function statisticsRecharge(params = {}) {
  return axios.get('recharge_order/statisticsRecharge', { params })
}

export function totalRecharge(params = {}) {
  return axios.get('recharge_order/totalRecharge', { params })
}

export function rechargeChart(params = {}) {
  return axios.post('recharge_order/rechargeChart', params)
}
